import React from 'react';
import { ContentGrid, Row, Col, Margin, P } from '@ovotech/element-v4';
import {
  ImageContainer,
  StyledImage,
  ModalStepTitle,
} from '../PreEligibilityProducts.styled';
import EVAnytimeApp from '@/src/resources/chargeAnytime/ev-anytime-app.png';
import { Media } from '@/src/components/Media';
import { breakpoints } from '@/src/utils/mediaQuery';

export const WhatYouGetStep1: React.FC = () => (
  <Margin top={6}>
    <ContentGrid size="12">
      <Row isNested>
        <Col small={12} medium={8}>
          <ModalStepTitle>Charge for less, everywhere you go.</ModalStepTitle>
          <Margin bottom={3}>
            <P>
              Get an annual public charging voucher to power your EV wherever
              you go.
            </P>
          </Margin>
          <Media query={breakpoints.mediumDown}>
            <ImageContainer>
              <StyledImage
                src={EVAnytimeApp}
                alt="Charging network illustration"
              />
            </ImageContainer>
          </Media>
          <Margin bottom={3}>
            <P>
              Our extensive network gives you access to the UK’s biggest
              charging networks. This includes <strong>50,000+ UK</strong>{' '}
              chargers and <strong>400,000+ chargers</strong> in Europe.
            </P>
          </Margin>
        </Col>
        <Media query={breakpoints.mediumUp}>
          <Col small={12} medium={4}>
            <ImageContainer>
              <StyledImage
                src={EVAnytimeApp}
                alt="Charging network illustration"
              />
            </ImageContainer>
          </Col>
        </Media>
      </Row>
    </ContentGrid>
  </Margin>
);
